module.exports = __webpack_public_path__ + "img/ruihong_swiper_07.97f208dc.jpg";